import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { GetAllRequestResponse } from '@modules/regular-user/requests/domain/entities/requests.entity';
import { API_ENDPOINTS } from '@typings/api-endpoints.type';
import { buildQueryParams } from '@utils/query';
import { map, Observable } from 'rxjs';
import {
  Client,
  GetClientsResponse,
  GetMemberResponse,
  Member,
  RemoveAndAssignRequest,
} from '../../domain/entities/clients.entity';
import { ClientsServices } from '../../domain/services/clients.service';

@Injectable()
export class ClientsServicesImpl implements ClientsServices {
  constructor(private client: HttpClient) {}

  getAllClients(companyId: string): Observable<GetClientsResponse> {
    const params = new HttpParams()
      .set('_parentCompanyId', companyId)
      .set('populate', 'members');
    return this.client
      .get<GetClientsResponse>(
        environment.apiDomain + API_ENDPOINTS.CLIENT.MY_CLIENT(),
        { params }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  createClient(client: any): Observable<any> {
    if (client.industry === '') delete client.industry;
    return this.client
      .post<any>(environment.apiDomain + API_ENDPOINTS.CLIENT.CREATE(), client)
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  getClientById(client: any): Observable<any> {
    const params = new HttpParams()
      .set('populate', 'members')
      .set('populate', 'administrator')
      .set('_id', client);
    return this.client
      .get<GetClientsResponse>(
        environment.apiDomain + API_ENDPOINTS.CLIENT.MY_CLIENT(),
        { params }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  removeClient(client: any): Observable<GetClientsResponse> {
    const params = new HttpParams().set('_id', client);
    return this.client
      .delete<GetClientsResponse>(
        environment.apiDomain + API_ENDPOINTS.CLIENT.MY_CLIENT(),
        { params }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  removeMember(memberId: string): Observable<GetMemberResponse> {
    const params = new HttpParams().set('_id', memberId);
    return this.client
      .delete<GetMemberResponse>(
        environment.apiDomain + API_ENDPOINTS.MEMBER.DELETE(),
        { params }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  getMemberById(memberId: string): Observable<GetMemberResponse> {
    const params = new HttpParams()
      .set('_id', memberId)
      .set('populate', '_profilePicture');
    return this.client
      .get<GetMemberResponse>(
        environment.apiDomain + API_ENDPOINTS.MEMBER.GET_ALL(),
        { params }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  updateMember(
    member: Member,
    memberId: string
  ): Observable<GetMemberResponse> {
    return this.client
      .patch<GetMemberResponse>(
        environment.apiDomain + API_ENDPOINTS.MEMBER.UPDATE(memberId),
        member
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  addMember(member: Member): Observable<GetMemberResponse> {
    return this.client
      .post<GetMemberResponse>(
        environment.apiDomain + API_ENDPOINTS.MEMBER.MULTIPLE_INVITE(),
        {
          members: [member],
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  updateClient(
    client: Client,
    clientId: string
  ): Observable<GetClientsResponse> {
    const params = new HttpParams().set('_id', clientId);

    return this.client
      .patch<GetClientsResponse>(
        environment.apiDomain + API_ENDPOINTS.CLIENT.UPDATE(clientId),
        client
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  getPendingRequestsByMember(
    memberId: string
  ): Observable<GetAllRequestResponse> {
    const query = {
      limit: 1,
      populate: ['requester', 'approvals', 'action'],
      // filter: {
      //   status: 'pending',
      //   'approvals._approver': memberId,
      // },
      filter: {
        status: 'pending',
        approvals: {
          $elemMatch: {
            _approver: memberId,
          },
        },
      },
    };
    const params = buildQueryParams(query);

    return this.client
      .get<GetAllRequestResponse>(
        environment.apiDomain + API_ENDPOINTS.REQUEST.REQUESTS_COUNT(''),
        { params }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  addMultipleMembers(members: Member[]): Observable<GetMemberResponse> {
    return this.client
      .post<GetMemberResponse>(
        environment.apiDomain + API_ENDPOINTS.MEMBER.MULTIPLE_INVITE(),
        {
          members: members,
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  removeMemberAndAssign(
    data: RemoveAndAssignRequest
  ): Observable<GetMemberResponse> {
    return this.client
      .patch<GetMemberResponse>(
        environment.apiDomain + API_ENDPOINTS.MEMBER.REMOVE_ASSIGN(),
        data
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
}
